import { AccordionComponent } from './accordion.component';

export default angular
  .module('sfMobile.components.accordion', [])
  .component('sfAccordion', AccordionComponent).name;
